import { createFileRoute } from '@tanstack/react-router';
import GenerateCredentials from '@piwikpro/user-panel/src/components/Credentials/GenerateCredentials';

export const Route = createFileRoute('/_secured/profile/api-credentials/m/create')({
  component: GenerateCredentials,
});
